import { Injectable } from '@angular/core';

import { Me } from '@zeusm/shared/core/entities';
import { ProfileType } from '@zeusm/shared/core/enums';
import { hasSupportManagerRole } from '@zeusm/shared/session/user';

import {
  BUSINESS_TARGET_ROUTE,
  PERSONAL_MOBILE_HOME_ROUTE,
  PERSONAL_TARGET_ROUTE,
  PROFILE_NOT_FOUND_ROUTE,
  SUPPORT_TARGET_ROUTE,
} from '../constants';

@Injectable({ providedIn: 'root' })
export class ProfileRouteService {
  getSignedInTargetRoute(user: Me | null): string {
    if (this.isSupportOnlyUser(user)) {
      return SUPPORT_TARGET_ROUTE;
    }

    return user?.hasPersonalProfileAccess === false ? BUSINESS_TARGET_ROUTE : PERSONAL_TARGET_ROUTE;
  }

  getDefaultProfileRoute(activeProfile: ProfileType | null, isDesktop: boolean): string {
    if (activeProfile === ProfileType.BUSINESS) return BUSINESS_TARGET_ROUTE;
    if (activeProfile === ProfileType.SUPPORT) return SUPPORT_TARGET_ROUTE;

    return isDesktop ? PERSONAL_TARGET_ROUTE : PERSONAL_MOBILE_HOME_ROUTE;
  }

  getProfileRoot(profile: ProfileType | null): string | null {
    if (profile === ProfileType.BUSINESS) return BUSINESS_TARGET_ROUTE;
    if (profile === ProfileType.SUPPORT) return SUPPORT_TARGET_ROUTE;
    if (profile === ProfileType.USER || profile === ProfileType.TREASURER) return PERSONAL_TARGET_ROUTE;

    return null;
  }

  getNoProfilesRoute(): string {
    return PROFILE_NOT_FOUND_ROUTE;
  }

  getBusinessUnavailableFallbackRoute(hasPersonalProfileAccess: boolean): string {
    return hasPersonalProfileAccess ? PERSONAL_TARGET_ROUTE : PROFILE_NOT_FOUND_ROUTE;
  }

  getPersonalDesktopFallbackRoute(hasPersonalProfileAccess: boolean, hasBusinessProfiles: boolean): string {
    if (hasPersonalProfileAccess) {
      return PERSONAL_TARGET_ROUTE;
    }

    return hasBusinessProfiles ? BUSINESS_TARGET_ROUTE : PROFILE_NOT_FOUND_ROUTE;
  }

  getPersonalMobileFallbackRoute(hasPersonalProfileAccess: boolean, hasBusinessProfiles: boolean): string {
    if (hasPersonalProfileAccess) {
      return PERSONAL_MOBILE_HOME_ROUTE;
    }

    return hasBusinessProfiles ? BUSINESS_TARGET_ROUTE : PROFILE_NOT_FOUND_ROUTE;
  }

  isSupportOnlyUser(user: Me | null): boolean {
    if (!user) return false;

    return hasSupportManagerRole(user.roles) && user.hasPersonalProfileAccess === false && user.businessProfiles.length === 0;
  }

  hasAnyProfileAccess(hasPersonalProfileAccess: boolean, hasSupportProfileAccess: boolean, businessProfilesCount: number): boolean {
    return hasPersonalProfileAccess || hasSupportProfileAccess || businessProfilesCount > 0;
  }
}
